import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Upload } from "antd";
import { ReactComponent as AddIcon } from "@/assets/icons/add.svg";
import "@/assets/audioAddMusic.less";

const AudioWorkContentFooterRender = ({ uploadProps, handleStopUpload }) => {
  const { t } = useTranslation(["audioAddMusic"]);
  return (
    <div className="workplace-content-footer">
      <Upload {...uploadProps}>
        <Button onClick={handleStopUpload} type="primary" ghost icon={<AddIcon />} style={{ display: "flex", alignItems: "center" }}>
          {t("Add tracks")}
        </Button>
      </Upload>
    </div>
  );
};

export default AudioWorkContentFooterRender;
